<template>
    <div class="ui-facilita-register">
        <section class="ui-facilita-register-tasks">
            <section class="ui-facilita-register-tasks-content">
                <ui-select-2
                    v-model="form.data.taskType"
                    item-label="label"
                    return-value="value"
                    placeholder="Selecione"
                    label="Tipo:"
                    :search="false"
                    :data="taskTypeOptions"
                    :show-footer="false"
                    :loading="loader.taskTypeLoad"
                />

                <ui-input v-model="form.data.taskTitle" label="Título:" type="text" size="md" />

                <div class="time-values">
                    <div class="time-value date">
                        <ui-datepicker
                            v-model="form.data.taskDate"
                            groupicon="fal fa-calendar-alt"
                            type="date"
                            label="Data:"
                            :context="'today'"
                        />
                    </div>

                    <div class="time-value time">
                        <ui-input
                            v-model="form.data.taskHour"
                            groupicon="fal fa-clock"
                            type="time"
                            label="Hora:"
                            design="time-md"
                        />
                    </div>
                </div>

                <ui-textarea
                    v-model="form.data.taskNote"
                    placeholder="Digite..."
                    label="Descrição:"
                    rows="3"
                />
            </section>

            <section class="ui-facilita-register-tasks-footer">
                <ui-button
                    type="button"
                    design="md success mw-100"
                    :disabled="!canSubmit"
                    :loading="loader.loadSaveButton"
                    @click="submit"
                >
                    Salvar
                </ui-button>
            </section>
        </section>

        <div v-if="loader.loadSave && !loader.hasRegister" class="loading-card">
            <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
        </div>

        <register-tasks-card
            v-for="(card, index) in cardTasks.tasks"
            :key="card.id"
            is-edit
            disable-flag
            :load-new-card="loader.loadNewCard"
            :data="card"
            :index="index"
            :show-date="isYearChanged(index)"
            @delete-card="handleDeleteCard"
            @update-card="handleUpdateCard"
            @edit-card="handleEditCard"
        />

        <div v-if="lengthDataTasks == 0 && !loader.loadSave" class="no-data">
            Nenhuma tarefa cadastrada!
        </div>

        <div v-if="!(cardTasks.pagination.total == cardTasks.pagination.to)" class="button-tasks">
            <ui-button
                v-if="!hasButton"
                design="primary md"
                :loading="loader.hasRegister"
                @click="hasMoreTasks"
            >
                Carregar Mais
            </ui-button>
        </div>
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'
	import { uiDatepicker, uiInput, uiSelect2, uiTextarea } from '@/components/ui/form'
	import registerTasksCard from '../register-tasks-card'

	import { task } from '@/services/axios'

	import { alertMixin, helpersMixin, loaderMixin, utilMixin } from '@/mixins'

	import { mapActions, mapGetters } from 'vuex'
	import { defaultGtm } from './default'

	const moment = require('moment')

	require('moment/locale/pt-br')

	const defaultData = {
		taskTitle: '',
		taskNote: '',
		taskType: null,
		taskDate: null,
		taskHour: null,
	}

	const defaultLoader = {
		taskTypeLoad: false,
		loadSave: false,
		hasRegister: false,
		loadSaveButton: false,
		loadNewCard: false
	}

	export default {
		name: 'ui-facilita-register-tasks',
		components: {
			uiSelect2,
			uiButton,
			uiInput,
			uiDatepicker,
			uiTextarea,
			registerTasksCard,
			uiLoadIndicator
		},

		mixins: [helpersMixin, loaderMixin, alertMixin, utilMixin],

		props: {
			dealId: {
				type: Number,
				default: undefined
			},
			customerName: {
				type: String,
				default: ''
			}
		},

		data() {
			return {
				form: {
					data: { ...defaultData }
				},
				loader: { ...defaultLoader },
				taskTypeOptions: [],
				gtm: { ...defaultGtm() },
				hasButton: false
			}
		},

		computed: {
			...mapGetters('contractAttendanceTasks', {
				getDealId: 'getDealId',
				cardTasks: 'getTasks',
				lengthDataTasks: 'getLengthDataTasks'
			}),

			hasAHistorical() {
				let form = this.form.data
				return form.taskTitle &&
					this.$mx_hasValue(form.taskType) &&
					(form.taskDate == 'Data inválida' ? false : form.taskDate)
			},

			/**
			* Condicional que permite o envio do formulário.
			*/
			canSubmit() {
				return (this.hasAHistorical)
			},

			validateDealFormData() {
				let form = this.form.data
				let formData = {
					type: form.taskType,
					notes: form.taskNote,
					title: form.taskTitle,
					for_date: form.taskDate,
					for_hour: form.taskHour,
					deal_linked: this.getDealId,
					alerts: {
						0: {
							'mode' : 'minute',
							'interval' : 1
						}
					},
					users_assign : {
						users_assign : {
							user_id : '',
							mode: 'to_assign'
						}
					},
				}

				return formData
			}
		},

		watch: {
			'form.data.taskType'(newVal) {
				switch (newVal) {
					case 'chat':
						this.form.data.taskTitle = `Chat com ${this.customerName}`
					break
					case 'mail':
						this.form.data.taskTitle = `Enviar e-mail para ${this.customerName}`
					break
					case 'call':
						this.form.data.taskTitle = `Fazer ligação para ${this.customerName}`
					break
					case 'observation':
						this.form.data.taskTitle = `Observações para ${this.customerName}`
					break
					case 'proposal':
						this.form.data.taskTitle = `Fazer proposta para ${this.customerName}`
					break
					case 'visit':
						this.form.data.taskTitle = `Visitar ${this.customerName}`
					break
					case 'whatsapp':
						this.form.data.taskTitle = `Enviar mensagem no WhatsApp para ${this.customerName}`
					break
					default:
						this.form.data.taskTitle = ''
				}
			}
		},

		async mounted() {
			this.reset()
			await this.loadForm()

			if (this.cardTasks.tasks == 0) {
				await this.handleDataCards(1)
			}

			this.extractTime()
			window.addEventListener('message', this.handleCloseModal)
		},

		methods: {
			...mapActions('contractAttendanceTasks', [
				'getTasksCards',
				'createDealTasks',
				'deleteDealTasks',
				'updateDealTasks'
			]),

			extractTime() {
				let form = this.form.data
				if (form.taskHour == null) {
					const date = new Date()
					const hours = String(date.getHours()).padStart(2, '0')
					const minutes = String(date.getMinutes()).padStart(2, '0')
					form.taskHour = `${hours}:${minutes}`
				}
			},

			handleCloseModal(event) {
				this.$mx_setLoader('taskTypeLoad', true)
				if (event.data.event === 'modalEditTasksClosed') {

					this.updateDealTasks(event.data)
					// const index = this.cardTasks.tasks.findIndex(card => card.id == event.data.dataForm.id)
					// console.log('index', this.cardTasks[index].tasks);

					// const updatedUsers = this.cardTasks[index].tasks.users

					// if (index !== -1) {
					// 	this.cardTasks[index].tasks = { ...event.data.dataForm, users: updatedUsers }
					// }
					this.$mx_setLoader('taskTypeLoad', false)
				}
			},

			async handleEditCard(id) {
				const data = {
					card_id: id
				}

				this.$emit('modal-open-contracts-edit-tasks')
				this.openIframe('edit-tasks', data)
			},

			async handleDeleteCard(id) {
				try {
					await this.deleteDealTasks(id)
				} catch(error) {
					this.$mx_alertThisOnError(error)
				}
			},

			async handleUpdateCard(id, value) {
				let data = {
					'status': value ? 'closed' : 'open'
				}

				try {
					const response = await task.update('', id, data)
					this.$mx_alertSuccess(response.data.msg)
				} catch(error) {
					this.$mx_alertThisOnError(error)
				}
			},

			async handleDataCards(page) {
				this.loader.loadSave = true

				try {
					await this.getTasksCards(page)
					this.loader.loadSave = false
					this.hasButton = false
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.loadSave = false
					this.hasButton = false
				}
			},

			async hasMoreTasks() {
				if (this.cardTasks.pagination.page <= this.cardTasks.pagination.last_page) {
					this.loader.hasRegister = true
					await this.handleDataCards(this.cardTasks.pagination.page)
					this.loader.hasRegister = false
				}
			},

			/**
				* Reseta as listas de Responsáveis e Clientes.
				*/
			reset() {
				this.form.data = { ...defaultData }
				this.loader = { ...defaultLoader }
				this.hasButton = true
			},


			/**
			* Envia o Formulário caso a condicional esteja atendida.
			*/
			async submit() {
				this.loader.loadSaveButton = true
				this.loader.loadNewCard = true
				try {
					await this.createDealTasks(this.validateDealFormData)
					this.$gtm.trackEvent(this.gtm.submit)
					this.loader.loadSaveButton = false
					this.loader.loadNewCard = false
					this.reset()
					this.extractTime()
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.loadSaveButton = false
					this.loader.loadNewCard = false
				}
			},

			async loadForm() {
				if (!this.taskTypeOptions.length) {
					this.$mx_setLoader('taskTypeLoad', true)
					const response = await task.getAll('types', null)
					this.taskTypeOptions = response.data[0].fields
					this.$mx_setLoader('taskTypeLoad', false)
				}
			},

			isYearChanged(currentIndex) {
				if (currentIndex === 0) return true

				const currentYear = moment(this.cardTasks[currentIndex]?.tasks.created_at).year()
				const previousYear = moment(this.cardTasks[currentIndex - 1]?.tasks.created_at).year()

				return currentYear !== previousYear
			},

			/**
			 * Cria e emite um evento customizado para abrir um modal em um Iframe do painel
			 * Legado
			 */
			openIframe(name, data = null) {
				let event = new CustomEvent(`iframe--contracts-${name}`, { detail: data })

				window.parent.document.dispatchEvent(event)
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
